import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  ogImage?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = 'BlackBelts | A jornada da faixa preta, em um app',
  description = 'blackbelts.app: registre cada graduação, acompanhe presenças e construa o histórico da sua jornada no Jiu-Jitsu até a faixa preta.',
  ogImage,
}) => {
  useEffect(() => {
    // Update title
    document.title = title;

    // Helper to update meta tags
    const updateMetaTag = (name: string, content: string, property?: boolean) => {
      const attribute = property ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    updateMetaTag('description', description);

    // Open Graph
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:type', 'website', true);

    if (ogImage) {
      updateMetaTag('og:image', ogImage, true);
    }

    // Twitter
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    if (ogImage) {
      updateMetaTag('twitter:image', ogImage);
    }
  }, [title, description, ogImage]);

  return null;
};

export default SEO;
